import { Box, Typography, Sheet, Button } from '@mui/joy';

/**
 * Карточка для неоплативших: что закрыто и как открыть. Показывается рядом с «Сегодня».
 */
export default function FreeAccessCard({ trialDaysLeft, onChoose }) {
    const label = trialDaysLeft != null ? `Бесплатный доступ · триал ${trialDaysLeft} дн.` : 'Бесплатный доступ';
    return (
        <Sheet variant="outlined" sx={{
            p: { xs: 2, sm: 2.5 }, borderRadius: '16px', borderColor: '#DA7756', bgcolor: 'background.surface',
            display: 'flex', flexDirection: 'column', gap: 1, justifyContent: 'center',
        }}>
            <Typography level="body-xs" sx={{ textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700, color: '#B84C31' }}>
                {label}
            </Typography>
            <Typography sx={{ fontSize: { xs: 18, sm: 20 }, fontWeight: 700, letterSpacing: '-0.015em' }}>
                Откройте весь курс APEX
            </Typography>
            <Typography level="body-sm" sx={{ color: 'text.secondary' }}>
                16 учебных планов, 10 200+ тестов, 3 900+ клинических задач, 130 видеолекций, Anki и PDF.
            </Typography>
            <Box>
                <Button onClick={onChoose} sx={{ mt: 0.5, bgcolor: '#37352F', color: '#fff', fontWeight: 700, borderRadius: '10px', '&:hover': { bgcolor: '#1F1F1F' } }}>
                    Выбрать тариф
                </Button>
            </Box>
        </Sheet>
    );
}
